// IMPORT PACKAGE REFERENCES

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// IMPORT PROJECT REFERENCES

import { LoginPage } from '../pages/LoginPage';
//import { LandingPage } from '../pages/LandingPage/LandingPage';
import { SegmentPage } from '../pages/Segments/SegmentPage';
import { SegmentDetailsPage } from '../pages/Segments/Details/SegmentDetailsPage';
import { EquipmentPage } from '../pages/Equipment/EquipmentPage';
import { EquipmentDetailsPage } from '../pages/Equipment/Details/EquipmentDetailsPage';
import { ProductDetailsPage } from '../pages/Products/Details/ProductDetailsPage';
import { PlanogramCreationPage } from '../pages/Planograms/PlanogramCreationPage';
import { ProductsPage } from '../pages/Products/ProductsPage';
import { StickerPage } from '../pages/Stickers/StickerPage';
import { StickerDetailPage } from '../pages/Stickers/Detail/StickerDetailPage';
import { PrivateRoute } from './PrivateRoute';
import { Sidebar } from '../Navigation/Sidebar';

/* 
    Manage the authorisation and routing of the user based on the provided URL parameters. 
*/

class AppRouter extends React.Component {
    state = {
        collapsed: false
    };

    onCollapse = collapsed => {
        this.setState({ collapsed });
       
    };

    render() {
        return (
            <BrowserRouter>
                <Fragment>
                    {this.props.loggedIn && (
                        <Fragment>
                            <div className='page-container'>
                                <div className={'left-panel open'}>
                                    <Sidebar/>
                                </div>
                                <div className='right-panel'>
                                    <Switch>
                                        <PrivateRoute loggedIn={this.props.loggedIn} path='/segments' component={SegmentPage} exact={true} />
                                        <PrivateRoute loggedIn={this.props.loggedIn} path='/equipment' component={EquipmentPage} exact={true} />
                                        <PrivateRoute loggedIn={this.props.loggedIn} path='/products' component={ProductsPage} exact={true} />
                                        <PrivateRoute loggedIn={this.props.loggedIn} path='/stickers' component={StickerPage} exact={true} />
                                        <PrivateRoute loggedIn={this.props.loggedIn} path='/stickers/:stickerId' component={StickerDetailPage} exact={true} />
                                        <PrivateRoute loggedIn={this.props.loggedIn} path='/segments/:segmentId' component={SegmentDetailsPage} exact={true}/>
                                        <PrivateRoute loggedIn={this.props.loggedIn} path='/equipment/:equipmentId' component={EquipmentDetailsPage} exact={true}/>
                                        <PrivateRoute loggedIn={this.props.loggedIn} path='/equipment/:equipmentId/planogram-creator' component={PlanogramCreationPage} exact={true}/>
                                        <PrivateRoute loggedIn={this.props.loggedIn} path='/products/:productId' component={ProductDetailsPage} exact={true}/>
                                        <Redirect to='/segments' />
                                    </Switch>
                                </div>
                            </div>
                        </Fragment>
                    )}
                    {!this.props.loggedIn && 
                        <Switch>
                            <Route path='/login' component={LoginPage} />
                            <Redirect to='/login' />
                        </Switch>
                    }
                </Fragment>
            </BrowserRouter>
        );
    }
}

AppRouter.propTypes = {
    loggedIn: PropTypes.bool.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { loggedIn } = state.userReducer;
    return { loggedIn };
};

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

const hoc = connect(
    mapStateToProps,
    mapDispatchToProps
)(AppRouter);

// EXPORT COMPONENT
export { hoc as AppRouter };


// WEBPACK FOOTER //
// ./src/components/routers/AppRouter.js